import * as $ from "jquery";
import {$body} from "Core/Body";
import {getCurrentLanguage} from 'Core/Languages';
import {Step3Selectors} from 'Components/Cart/Step3/Step3Selectors';
import Step3FormValidation from "Components/Validation/Step3FormValidation";
import {Notifications} from "Core/Notifications";
import {CartService, CartServiceResponse} from "Components/Cart/CartService";

export const Step3Component = (() => {

    const lang = getCurrentLanguage;

    function showButton() {
        setTimeout(()=>{$(Step3Selectors.COMMON.SUBMIT_BTN).removeClass("d-none")}, 500);
    }

    function preSubmitForm(e) {
        e.preventDefault();
        let step3FormValidation = new Step3FormValidation();
        if(step3FormValidation.validate()){
            $(Step3Selectors.COMMON.SUBMIT_BTN).prop('disabled', true);
            $(Step3Selectors.COMMON.LIGHT_PRELOADER).removeClass("d-none");

            CartService.checkProductInTheBasket(lang).done(
                function (res: CartServiceResponse) {
                    if (res.result == false) {
                        if (res.redirect != undefined && res.redirect != null) {
                            window.location.replace(res.redirect);
                        }
                        return false;
                    } else {
                        $(Step3Selectors.COMMON.FORM).submit();
                    }
            });
        }else{
            Notifications.add(`Wystąpił błąd w wysyłaniu formularza`, 'error');
        }

        return false;
    }


    $(window).on("load", showButton);
    $body.on("click", Step3Selectors.COMMON.SUBMIT_BTN, preSubmitForm);

    return true;
})();import * as $ from "jquery";
import {$body} from "Core/Body";
import {getCurrentLanguage} from 'Core/Languages';
import {Step3Selectors} from 'Components/Cart/Step3/Step3Selectors';
import Step3FormValidation from "Components/Validation/Step3FormValidation";
import {Notifications} from "Core/Notifications";
import {CartService, CartServiceResponse} from "Components/Cart/CartService";

export const Step3Component = (() => {

    const lang = getCurrentLanguage;

    function showButton() {
        setTimeout(()=>{$(Step3Selectors.COMMON.SUBMIT_BTN).removeClass("d-none")}, 500);
    }

    function preSubmitForm(e) {
        e.preventDefault();
        let step3FormValidation = new Step3FormValidation();
        if(step3FormValidation.validate()){
            $(Step3Selectors.COMMON.SUBMIT_BTN).prop('disabled', true);
            $(Step3Selectors.COMMON.LIGHT_PRELOADER).removeClass("d-none");

            CartService.checkProductInTheBasket(lang).done(
                function (res: CartServiceResponse) {
                    if (res.result == false) {
                        if (res.redirect != undefined && res.redirect != null) {
                            window.location.replace(res.redirect);
                        }
                        return false;
                    } else {
                        $(Step3Selectors.COMMON.FORM).submit();
                    }
            });
        }else{
            Notifications.add(`Wystąpił błąd w wysyłaniu formularza`, 'error');
        }

        return false;
    }


    $(window).on("load", showButton);
    $body.on("click", Step3Selectors.COMMON.SUBMIT_BTN, preSubmitForm);

    return true;
})();